// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"anticlockwise"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M8.99902 7H21.999V20H8.99902V7Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.99902 7H21.999V20H8.99902V7Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12.0003 3H7.3333C6.22887 3 5.33349 3.89522 5.3333 4.99965L5.33235 10.5H4.7768L1.99902 7.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const AnticlockwiseIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'anticlockwise',
    ref,
    icon: element,
  },
));

AnticlockwiseIcon.displayName = 'AnticlockwiseIcon';

export default AnticlockwiseIcon;
